module.exports = __webpack_public_path__ + "static/integrations-with-apps-min-774a67f243ef3b69d36e094820d33d32.png";